import { createContext, ReactNode, use } from "react";

type DepthContextValue = {
    depth: number;
};

type DepthContextProviderProps = {
    initial?: number;
    children: ReactNode;
};

export const DepthContext = createContext<DepthContextValue | undefined>(
    undefined
);
DepthContext.displayName = "DepthContext";

export const Depth = ({ initial, children }: DepthContextProviderProps) => {
    const context = use(DepthContext);

    const depth = initial ?? (context ? context.depth + 1 : 0);

    return (
        <DepthContext
            value={{
                depth: depth
            }}
        >
            {children}
        </DepthContext>
    );
};

export const useDepth = () => {
    const context = use(DepthContext);

    if (!context?.depth) {
        return { depth: 0 };
    } else {
        return { depth: context.depth };
    }
};
